module.exports = __webpack_public_path__ + "img/BannerNoClientesMobile.1a42c6bb.png";